var CollectionTutorialPublishingState;

CollectionTutorialPublishingState = (function() {
  function CollectionTutorialPublishingState() {
    this.changeStateCallbacks = [];
  }

  CollectionTutorialPublishingState.prototype = {
    addChangeStateCallback: function(callback) {
      return this.changeStateCallbacks.push(callback);
    },

    setState: function(state) {
      this.state = state;
      return this._stateChanged();
    },

    public: function() {
      return 'public' === this.state;
    },

    published: function() {
      return this["public"]() || 'published' === this.state;
    },

    unpublished: function() {
      return !this.published();
    },

    _stateChanged: function() {
      var callback, i, len, ref, results;
      ref = this.changeStateCallbacks;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        callback = ref[i];
        results.push(callback(this));
      }
      return results;
    }
  }

  return CollectionTutorialPublishingState;

})();

SOPHIA.publisher || (SOPHIA.publisher = {});

SOPHIA.publisher.publishingState = new CollectionTutorialPublishingState;

